import React from 'react';
import SupportTicketsSection from '../../../sections/AdminDashboard/Support/SupportTickets';

const SupportTickets = () => {
  return <SupportTicketsSection />;
};

export default SupportTickets;
